import React from 'react';

import { formatISO9075 } from 'date-fns';
import { observer } from 'mobx-react-lite';

import { NotificationVideoCell } from '^/userWeb/Components/NotificationVideoCell';
import { FilledLoadingCircle } from '^/userWeb/Components/StatusViews/LoadingCircle';
import { routes } from '^/userWeb/routes';

import { VisitorDetectedTabViewModel } from './VisitorDetectedTabs.viewmodel';

export const VisitorDetectedTab: React.FC<{
  viewmodel: VisitorDetectedTabViewModel,
}> = observer(function VisitorDetectedTab({
  viewmodel,
}) {
  if (viewmodel.list.status === 'loading') {
    return <FilledLoadingCircle />;
  }
  if (viewmodel.list.status === 'failure') {
    return <h1> Error </h1>;
  }
  return (
    <>
      {viewmodel.list.value.map((
        detected,
        nth,
      ) => {

        console.log('🔍 detected:', detected);
        if (detected.status === 'loading') {
          return (
            <NotificationVideoCell
              // eslint-disable-next-line react/no-array-index-key
              key={`loading_${nth}`}
              date=" - "
              title="로딩 중 입니다..."
              src={null}
            />
          );
        }
        if (detected.status === 'failure') {
          return (
            <NotificationVideoCell
              // eslint-disable-next-line react/no-array-index-key
              key={`error_${nth}`}
              date=" - "
              title="에러가 발생하였습니다"
              src={null}
            />
          );
        }
        const dateString = formatISO9075(
          detected.value.createdAt,
        );
        return (
          <NotificationVideoCell
            // FIXME: cowmount.value.isCheck
            key={detected.value.id}
            date={dateString}
            title={`카메라${detected.value.cameraName} 에서 출입이 발생하였습니다`}
            src={detected.value.videoUrl || null}
            onDoubleClick={() => {
              routes.visitorHistory({
                fullscreenNth: nth,
                freshness: viewmodel.freshness,
              }).push();
            }}
          />
        );
      })}
    </>
  );
});
